import {SetGetDailyList} from './thunk/setGetDailyList';
import {SetGetDailyView} from './thunk/setGetDailyView';
import {SetGetLogin} from './thunk/setGetLogin';

export const Thunks = {
    SetGetDailyList,
    SetGetDailyView,
    SetGetLogin
}